(function () {
  if (!window.location.pathname.endsWith('/collections/cutting-mats')) {
    return;
  }

  const pagination = document.querySelector('.pagination-wrapper');
  const gridContainer = document.getElementById('ProductGridContainer');

  function getGridItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return [];
    }

    return [...grid.querySelectorAll('.grid__item[data-ovs-mat-series], .grid__item[data-ovs-mat-size], .grid__item[data-ovs-mat-color]')];
  }

  function normalizeMatColor(value) {
    const aliases = {
      'grape-purple': 'purple',
      'matcha-green': 'green',
      'mint-green': 'green',
      'sakura-pink': 'pink',
      'sky-blue': 'blue',
      'sky-gray': 'gray',
      'sky-grey': 'gray',
    };
    const trimmed = String(value || '').trim();
    return aliases[trimmed] || trimmed;
  }

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => (param === 'ovs_mat_color' ? normalizeMatColor(value) : value.trim()))
      .filter((value) => value !== '');
  }

  function selectedValues(selector, attribute) {
    const values = new Set();
    document.querySelectorAll(selector).forEach((input) => {
      if (!input.checked) {
        return;
      }
      const value = input.getAttribute(attribute) || '';
      if (value !== '') {
        values.add(value);
      }
    });

    return [...values];
  }

  function selectedSeries() {
    return selectedValues('.ovs-mat-series-input:checked', 'data-ovs-mat-series');
  }

  function selectedSizes() {
    return selectedValues('.ovs-mat-size-input:checked', 'data-ovs-mat-size');
  }

  function selectedColors() {
    return selectedValues('.ovs-mat-color-input:checked', 'data-ovs-mat-color');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-mat-series-input').forEach((input) => {
      const label = input.closest('.ovs-mat-series-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
    document.querySelectorAll('.ovs-mat-size-input').forEach((input) => {
      const label = input.closest('.ovs-mat-size-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
    document.querySelectorAll('.ovs-mat-color-input').forEach((input) => {
      const label = input.closest('.ovs-mat-color-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncPanels(changedInput, attribute) {
    const value = changedInput.getAttribute(attribute) || '';
    if (value === '') {
      return;
    }

    document.querySelectorAll(`[${attribute}="${value}"]`).forEach((input) => {
      input.checked = changedInput.checked;
    });
  }

  function syncCheckboxesFromUrl() {
    const series = parseList('ovs_mat_series');
    const sizes = parseList('ovs_mat_size');
    const colors = parseList('ovs_mat_color');

    document.querySelectorAll('.ovs-mat-series-input').forEach((input) => {
      input.checked = series.includes(input.getAttribute('data-ovs-mat-series') || '');
    });
    document.querySelectorAll('.ovs-mat-size-input').forEach((input) => {
      input.checked = sizes.includes(input.getAttribute('data-ovs-mat-size') || '');
    });
    document.querySelectorAll('.ovs-mat-color-input').forEach((input) => {
      input.checked = colors.includes(input.getAttribute('data-ovs-mat-color') || '');
    });

    syncCheckboxLabels();
  }

  function buildUrl(series, sizes, colors) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_mat_series');
    url.searchParams.delete('ovs_mat_size');
    url.searchParams.delete('ovs_mat_color');
    url.searchParams.delete('page');

    if (series.length > 0) {
      url.searchParams.set('ovs_mat_series', series.join(','));
    }
    if (sizes.length > 0) {
      url.searchParams.set('ovs_mat_size', sizes.join(','));
    }
    if (colors.length > 0) {
      url.searchParams.set('ovs_mat_color', colors.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    document.querySelectorAll('#ProductCountDesktop, #ProductCountMobile, .product-count__text span').forEach((node) => {
      node.textContent = visibleCount === 1 ? '1 product' : visibleCount + ' products';
    });
  }

  function togglePagination(series, sizes, colors) {
    if (!pagination) {
      return;
    }

    pagination.hidden = series.length > 0 || sizes.length > 0 || colors.length > 0;
  }

  function setItemVisibility(item, show) {
    item.hidden = !show;
    item.classList.toggle('hidden', !show);
    item.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function filtersActive() {
    return selectedSeries().length > 0 || selectedSizes().length > 0 || selectedColors().length > 0;
  }

  function applyFilters(updateHistory) {
    const series = selectedSeries();
    const sizes = selectedSizes();
    const colors = selectedColors();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemSeries = item.getAttribute('data-ovs-mat-series') || '';
      const itemSize = item.getAttribute('data-ovs-mat-size') || '';
      const itemColor = item.getAttribute('data-ovs-mat-color') || '';
      let show = true;

      if (series.length > 0) {
        show = itemSeries !== '' && series.includes(itemSeries);
      }
      if (show && sizes.length > 0) {
        show = itemSize !== '' && sizes.includes(itemSize);
      }
      if (show && colors.length > 0) {
        show = itemColor !== '' && colors.includes(itemColor);
      }

      setItemVisibility(item, show);
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(series, sizes, colors);

    if (updateHistory) {
      const url = buildUrl(series, sizes, colors);
      window.history.pushState({ ovsMatFilters: true }, '', url.pathname + url.search);
    }
  }

  function stopFacetFormPropagation(event) {
    event.stopPropagation();
  }

  function bindGroup(selector, attribute) {
    document.querySelectorAll(selector).forEach((input) => {
      input.addEventListener('input', stopFacetFormPropagation);
      input.addEventListener('change', (event) => {
        stopFacetFormPropagation(event);
        syncPanels(input, attribute);
        applyFilters(true);
      });
    });
  }

  bindGroup('.ovs-mat-series-input', 'data-ovs-mat-series');
  bindGroup('.ovs-mat-size-input', 'data-ovs-mat-size');
  bindGroup('.ovs-mat-color-input', 'data-ovs-mat-color');

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  if (gridContainer) {
    const observer = new MutationObserver(() => {
      if (filtersActive()) {
        applyFilters(false);
      }
    });
    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
